"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
const Card_1 = require("../Card");
exports.Table = react_1.forwardRef((_a, ref) => {
    var { children, variant } = _a, props = __rest(_a, ["children", "variant"]);
    if (variant === 'card') {
        return (jsx_runtime_1.jsx(Card_1.Card, Object.assign({ maxWidth: "100%", overflowX: "auto" }, props, { children: jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "table", ref: ref, width: "100%" }, { children: children }), void 0) }), void 0));
    }
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ maxWidth: "100%", overflowX: "auto" }, props, { children: jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "table", ref: ref, width: "100%" }, { children: children }), void 0) }), void 0));
});
//# sourceMappingURL=index.js.map